import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";
import { cn } from "@/lib/utils";

interface DraggableMetricsGridProps {
  droppableId: string;
  children: React.ReactNode;
  onDragEnd: (result: DropResult) => void;
  className?: string;
  direction?: "horizontal" | "vertical";
  isEditMode?: boolean;
}

export const DraggableMetricsGrid = ({ 
  droppableId, 
  children, 
  onDragEnd, 
  className,
  direction = "horizontal",
  isEditMode = false
}: DraggableMetricsGridProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId} direction={direction}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={cn(
              "transition-all duration-200 rounded-xl",
              isEditMode && "p-3 -m-3",
              snapshot.isDraggingOver && isEditMode && "bg-primary/10 ring-2 ring-dashed ring-primary/40",
              className
            )}
          >
            {children}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

// Wrapper for multiple independent droppable areas
interface MultiDraggableGridProps {
  children: React.ReactNode;
  onDragEnd: (result: DropResult) => void;
}

export const MultiDraggableGrid = ({ children, onDragEnd }: MultiDraggableGridProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {children}
    </DragDropContext>
  );
};

interface DroppableAreaProps {
  droppableId: string;
  children: React.ReactNode;
  className?: string;
  direction?: "horizontal" | "vertical";
  isEditMode?: boolean;
}

export const DroppableArea = ({ 
  droppableId, 
  children, 
  className,
  direction = "horizontal",
  isEditMode = false
}: DroppableAreaProps) => {
  return (
    <Droppable droppableId={droppableId} direction={direction}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={cn(
            "transition-all duration-200 rounded-xl",
            isEditMode && "p-4 -m-4",
            snapshot.isDraggingOver && isEditMode && "bg-primary/10 ring-2 ring-dashed ring-primary/40",
            className
          )}
        >
          {children}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};
